import { createFileRoute } from "@tanstack/react-router";
import { Pricing } from "@/features/public/Pricing";

export const Route = createFileRoute("/pricing")({ component: Pricing });
